import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || undefined,
};

// Config log removed for cleaner console in production.


// Prevent duplicate initialization in Next.js hot-reload
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Force local persistence to ensure sessions are preserved across redirects on mobile
if (typeof window !== 'undefined') {
  import('firebase/auth').then(({ setPersistence, browserLocalPersistence }) => {
    setPersistence(auth, browserLocalPersistence).catch((err) => {
      console.error('[FIREBASE] Persistence error:', err);
    });
  });
}

export const getAnalyticsAsync = async () => {
  if (typeof window !== 'undefined' && firebaseConfig.appId) {
    try {
      const { getAnalytics } = await import('firebase/analytics');
      return getAnalytics(app);
    } catch (err) {
      console.warn('[FIREBASE] Analytics failed to initialize:', err);
      return null;
    }
  }
  return null;
};

export default app;
